import {Link} from 'react-router-dom';
import {ReactNode} from 'react';

type ConditionalLinkProps = {
    to: string|null;
    children: ReactNode;
}

const ConditionalLink = ({to, children}: ConditionalLinkProps) => {
    return to
        ? <Link to={to}>{children}</Link>
        : <a href={'/404'}>{children}</a>
        ;
}

export default ConditionalLink;
